<!--
  - Copyright (c) 2021. Trade Research Advisory (Pty) Ltd, P.O.Box 336, Cornwall Hill, Irene, 0178
  - #  This file forms part of the Trade-DSM application frontend.
  - #  https://github.com/Tooblippe/trade-dsm-frontend
  -->

<template>
  <div v-if="!$store.state.tradeDSM.loading_indicator" class="white">
    <v-layout row>
      <v-flex class="xs12 sm12 lg12">
        <div class="body-2 font-weight-bold nav nav-tabs mt-2">
          <li>
            <a
              >Home market export characteristics for product
              <help-link help_id="2" style="float: right" />
              <v-btn
                v-if="!all_open_selection"
                class="white--text mr-0 pr-0"
                style="float: right"
                text
                x-small
                @click="all_open_selection = true"
              >
                <v-icon v-if="!all_open_selection"> mdi-chevron-triple-down</v-icon>
              </v-btn>
              <v-btn
                v-if="all_open_selection"
                class="white--text mr-0 pr-0"
                style="float: right"
                text
                x-small
                @click="all_open_selection = false"
              >
                <v-icon v-if="all_open_selection"> mdi-chevron-triple-up</v-icon>
              </v-btn>
            </a>
          </li>
        </div>
      </v-flex>
    </v-layout>
    <div class="tab-content">
      <div class="tab-pane active white black--text pl-3">
        <v-container fluid>
          <result_hover
            :all_open="all_open_selection"
            :explanation="get_dsm_result['REO_F4_1_Text']"
            :result="
              `${get_yes_no(
                'RCA1_0',
              )} <span class='ml-2 green--text rta_rta_text'>${share_text()}</span>`
            "
            heading="Home market is comparatively large exporter of product? [F4.1]"
          ></result_hover>

          <result_hover
            :all_open="all_open_selection"
            :explanation="get_dsm_result['REO_F4_2_Text']"
            :result="
              `${get_yes_no(
                'RTA_0',
              )} <span class='ml-2 green--text rta_rta_text'>${rta_text()}</span>`
            "
            heading="Home market has product export production capacity? [F4.2]"
          ></result_hover>
        </v-container>
      </div>
    </div>

    <v-layout row>
      <v-flex class="xs12 sm12 lg12">
        <div class="body-2 font-weight-bold nav nav-tabs mt-2">
          <li>
            <a class=""
              >Opportunity characteristics
              <help-link help_id="3" style="float: right" />
              <v-btn
                v-if="!all_open_export"
                class="white--text mr-0 pr-0"
                style="float: right"
                text
                x-small
                @click="all_open_export = true"
              >
                <v-icon v-if="!all_open_export"> mdi-chevron-triple-down</v-icon>
              </v-btn>
              <v-btn
                v-if="all_open_export"
                class="white--text mr-0 pr-0"
                style="float: right"
                text
                x-small
                @click="all_open_export = false"
              >
                <v-icon v-if="all_open_export"> mdi-chevron-triple-up</v-icon>
              </v-btn>
            </a>
          </li>
        </div>
      </v-flex>
    </v-layout>
    <div class="tab-content">
      <div class="tab-pane active white black--text pl-3">
        <v-container class="justify-center align-center" fluid>
          <result_hover_opportunities
            :all_open="all_open_export"
            :explanation="get_dsm_result['Overall_Text']"
            :result="opportunity"
            heading="Is this an overall opportunity?"
          ></result_hover_opportunities>

          <result_hover
            :all_open="all_open_export"
            :explanation="get_dsm_result['REO_F1_Text']"
            :result="get_yes_no('F1_Select')"
            heading="Market economy size, wealth, growth trends & risk?"
          ></result_hover>

          <result_hover
            :all_open="all_open_export"
            :explanation="get_dsm_result['REO_F2_Text']"
            :result="get_yes_no('F2_Select')"
            heading="Market import demand size and growth patterns?"
          ></result_hover>

          <result_hover
            :all_open="all_open_export"
            :explanation="get_dsm_result['REO_F2_4_Text']"
            :result="get_yes_no('F2_Positive')"
            heading="Market historical strong positive import demand growth?"
          ></result_hover>

          <result_hover
            :all_open="all_open_export"
            :explanation="get_dsm_result['REO_F3_1_Text']"
            :result="get_yes_no('F31_Select')"
            heading="Market trading with various alternative supplying countries"
          ></result_hover>

          <result_hover
            :all_open="all_open_export"
            :explanation="get_dsm_result['REO_F3_2_Text']"
            :result="get_yes_no('F32_Select')"
            heading="Market is relatively accessible in terms of tariffs & logistics?"
          ></result_hover>

          <result_hover
            :all_open="all_open_export"
            :explanation="get_dsm_result['REO_HM_Rank_Text']"
            :result="rank + ' out of ' + total_exporters"
            heading="Home market share of imports into target market [rank]:"
          ></result_hover>

          <result_hover
            :all_open="all_open_export"
            :explanation="supply.text"
            :image="supply.src"
            :result="null"
            heading="Home market supply into target market [REO Map Column]"
          ></result_hover>

          <result_hover
            :all_open="all_open_export"
            :explanation="demand.text"
            :image="demand.src"
            :result="null"
            heading="Target market demand characteristics [REO Map Row]"
          ></result_hover>

          <result_hover
            :all_open="all_open_export"
            :explanation="get_dsm_result['REO_Tariff_Text']"
            :heading="
              `Country x Product tariff for model:  ${format_ad_valorem(
                add_velorem_tariff / 100,
              )}% [${add_velorem_tariff_year}]`
            "
            :result="null"
          ></result_hover>
        </v-container>
      </div>
    </div>
  </div>
  <v-skeleton-loader
    v-else
    class="mx-auto mt-5"
    max-width="100%"
    type="card"
  ></v-skeleton-loader>
</template>
// place
<script>
import vFmt from '@/components/application-level/mixins/vFmt';
import {mapGetters} from 'vuex';
import result_hover from '@/components/trade-dsm-application/result-components/helpers/result-hover';
import result_hover_opportunities from '@/components/trade-dsm-application/result-components/helpers/result-hover-opportunities';
import helpLink from '@/components/application-level/help-system/help-link';
import {format_ad_valorem} from '@/components/application-level/js_functions/jsFunctions';

export default {
  name: 'DsmSingleTextFilters',
  mixins: [vFmt],
  components: {result_hover_opportunities, result_hover, helpLink},
  data: () => {
    return {
      all_open_selection: false,
      all_open_export: false,
    };
  },
  computed: {
    ...mapGetters(['getDsmAppState', 'get_dsm_result', 'get_dsm_result']),

    add_velorem_tariff() {
      try {
        return (
          this.getDsmAppState.dsm_filter_setttings.results.dsmresult[0][
            'ad_valorem_tariff'
          ] * 100
        );
      } catch (e) {
        return -1;
      }
    },
    add_velorem_tariff_year() {
      try {
        return this.getDsmAppState.dsm_filter_setttings.results.dsmresult[0][
          'ad_valorem_tariff_year'
        ];
      } catch (e) {
        return -1;
      }
    },
    total_exporters() {
      try {
        return this.$store.getters.getDsmAppState.dsm_filter_setttings.results
          .dsmresult[0]['Nr_Importers'];
      } catch (e) {
        return '0';
      }
    },
    rank() {
      try {
        return this.$store.getters.getDsmAppState.dsm_filter_setttings.results
          .dsmresult[0]['HM_Rank'] >= 0
          ? this.$store.getters.getDsmAppState.dsm_filter_setttings.results.dsmresult[0][
              'HM_Rank'
            ]
          : 0;
      } catch (e) {
        return '0';
      }
    },

    supply() {
      try {
        let home_market = this.$store.state.app.selectedHomeCountry;
        let target_market = this.codeToMarket(
          this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.selections.markets
            .C_Code[0],
        );
        let hs6_code = this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META
          .selections.products.HS6_Code[0];
        let tooltip_text =
          target_market + ' does not seem to have sufficiant information';
        if (
          this.$store.getters.getDsmAppState.dsm_filter_setttings.results.dsmresult[0][
            'REO_col'
          ] > 0
        ) {
          switch (
            this.$store.getters.getDsmAppState.dsm_filter_setttings.results.dsmresult[0][
              'REO_col'
            ]
          ) {
            case 1:
              tooltip_text =
                home_market +
                ' to date has supplied none or relatively little of ' +
                target_market +
                '’s total import demand for ' +
                hs6_code +
                ' - hence located in REO MAP column 1.';
              break;
            case 2:
              tooltip_text =
                home_market +
                ' to date has supplied an intermediately small share of ' +
                target_market +
                '’s total import demand for ' +
                hs6_code +
                ' - hence located in REO MAP column 2.';
              break;
            case 3:
              tooltip_text =
                home_market +
                ' to date has supplied an intermediately large share of ' +
                target_market +
                '’s total import demand for ' +
                hs6_code +
                ' - hence located in REO MAP column 3.';
              break;
            case 4:
              tooltip_text =
                home_market +
                ' to date has supplied a relatively large share of ' +
                target_market +
                '’s total import demand for ' +
                hs6_code +
                ' - hence located in REO MAP column 4.';
              break;
          }
          return {
            src: `/reo_pics/MShare_0${
              this.$store.getters.getDsmAppState.dsm_filter_setttings.results
                .dsmresult[0]['REO_col']
            }.png`,
            text: tooltip_text,
          };
        } else {
          return {src: '/reo_pics/error.png', text: tooltip_text};
        }
      } catch (v) {
        return '';
      }
    },
    // Mve to backend
    demand() {
      try {
        let target_market = this.codeToMarket(
          this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.selections.markets
            .C_Code[0],
        );
        let tooltip_text =
          'This opportunity is not classified as a realistic opportunity and therefore the market characteristics are not determined.';

        if (
          this.$store.getters.getDsmAppState.dsm_filter_setttings.results.dsmresult[0][
            'REO_row'
          ] > 0
        ) {
          switch (
            this.$store.getters.getDsmAppState.dsm_filter_setttings.results.dsmresult[0][
              'REO_row'
            ]
          ) {
            case 1:
              tooltip_text =
                target_market +
                "'s import demand is relatively large in global terms, but stable or ‘flat’ from a growth perspective - hence located in REO MAP row 1.";
              break;
            case 2:
              tooltip_text =
                target_market +
                "'s import demand shows that it is growing in both the short and long term, but relative to other global markets it is a small market - hence located in REO MAP row 2.";
              break;
            case 3:
              tooltip_text =
                target_market +
                "'s import demand is relatively large in global terms and has exhibited strong growth in the last 2 years (for which data is available) - hence located in REO MAP row 3.";
              break;
            case 4:
              tooltip_text =
                target_market +
                "'s import demand is relatively large in global terms and has exhibited strong growth over the last 5 years (for which data is available), but less so in the latest 2 years - hence located in REO MAP row 4.";
              break;
            case 5:
              tooltip_text =
                target_market +
                "'s import demand is relatively large in global terms and has exhibited strong growth over the latest 2 years as well as in the last 5 years (for which data is available) - hence located in REO MAP row 5.";
              break;
          }
          return {
            src: `/reo_pics/MSize_0${
              this.$store.getters.getDsmAppState.dsm_filter_setttings.results
                .dsmresult[0]['REO_row']
            }.png`,
            text: tooltip_text,
          };
        } else {
          return {src: '/reo_pics/error.png', text: tooltip_text};
        }
      } catch (e) {
        return '';
      }
    },
    opportunity() {
      try {
        let r = this.$store.getters.getDsmAppState.dsm_filter_setttings.results
          .dsmresult[0];
        let opp =
          r['REO_col'] > 0 &&
          r['REO_row'] > 0 &&
          r['F2_Select'] &&
          r['F31_Select'] &&
          r['F32_Select'];
        if (opp) {
          return `<span class="yes">✓</span>`;
        } else {
          return `<span class="no">x </span>`;
        }
      } catch (v) {
        return '';
      }
    },
  },
  methods: {
    format_ad_valorem,
    rta_text() {
      let s = '';
      s += 'RTA = ';
      s += this.$store.state.tradeDSM.dsm_filter_setttings.Filters.F4.entries[4].max.toFixed(
        4,
      );
      return s;
    },

    share_text() {
      let s = '';

      s += 'RCA = ';
      s += this.$store.state.tradeDSM.dsm_filter_setttings.Filters.F4.entries[2].max.toFixed(
        4,
      );
      s += ' ';

      if (this.$store.state.app.selectedModelName !== 'National') {
        s += this.$store.state.user.userServerInfo.subscriptions[0][
          'summary_share_perc_text'
        ];
        // ----------
        s += (
          this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.query_results
            .TW_Share_Prov * 100
        )
          .toFixed(2)
          .toString();
        s += '%';

        return s;
      } else {
        return (s += '');
      }
    },
    get_yes_no(dsmFilterToCheck) {
      try {
        let yesno = this.$store.getters.getDsmAppState.dsm_filter_setttings.results
          .dsmresult[0][dsmFilterToCheck];
        if (yesno) {
          return '<span class="yes">✓</span>';
        } else {
          return '<span class="no">x&nbsp;</span>';
        }
      } catch (v) {
        return '';
      }
    },
  },
};
</script>

<style scoped>
.disabled {
  pointer-events: none;
}

.top_only {
  border-top: 1px dashed lightgrey;
  padding-left: 3px;
}

.right_only {
  border-right: 1px dashed lightgrey;
  padding-left: 3px;
}
.rta_rta_text {
  font-size: 0.78rem;
}
</style>
